import type DxfArrayScanner from '../DxfArrayScanner';
import type { ScannerGroup } from '../DxfArrayScanner';
import parsePoint from '../shared/parsePoint';
import isMatched from '../shared/isMatched';

// scanner 위치는 읽히기 전이어야 함
export default function parseHeader(curr: ScannerGroup, scanner: DxfArrayScanner) {
    // interesting variables:
    //  $ACADVER, $VIEWDIR, $VIEWSIZE, $VIEWCTR, $TDCREATE, $TDUPDATE
    // http://www.autodesk.com/techpubs/autocad/acadr14/dxf/header_section_al_u05_c.htm
    // Also see VPORT table entries
    let currVarName = null;
    const header: any = {};
    let current = curr;

    while (!isMatched(current, 0, 'EOF')) {
        if (isMatched(current, 0, 'ENDSEC')) {
            break;
        }

        if (current.code === 9) {
            currVarName = current.value;
        } else if (current.code === 10) {
            header[currVarName] = parsePoint(scanner);
        } else {
            header[currVarName] = current.value;
        }
        current = scanner.next();
    }
    return header;
}
